<template>
  <div style="overflow-x: hidden">
    <section class="breadcrumb_nav">
      <div class="breadcrumb_nav_img relative">
        <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/articles/image_1668499027_21.jpg" alt="img" />
        <h2 class="breadcrumb_nav_title text-center hidden-xs">{{ $t("common.contactUs") }}</h2>
      </div>

      <div class="breadcrumb_nav_wrap">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb_nav_box">
                <ul class="breadcrumb_nav_list">
                  <li>
                    <a hrefs="/">{{ $t("common.home") }}</a>
                  </li>

                  <li>
                    <i class="fa fa-angle-double-right"></i>
                    <span> {{ $t("common.contactUs") }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div digood-id="contact-hd-page">
      <section class="section">
        <div class="container">
          <div class="row">
            <div class="col-sm-6 col-md-6 col-lg-3 m-15px-tb wow fadeInUp" style="visibility: visible; animation-name: fadeInUp">
              <div class="feature-box-01 gtag_report_btn">
                <div class="icon theme-g-bg">
                  <i class="fa fa-envelope"></i>
                </div>
                <h4>{{ $t("contact.email") }}</h4>
                <p>
                  <a href="mailto:info@midonkey.com">info@midonkey.com</a>
                </p>
              </div>
            </div>

            <div class="col-sm-6 col-md-6 col-lg-3 m-15px-tb wow fadeInUp" style="visibility: visible; animation-name: fadeInUp">
              <div class="feature-box-01 gtag_report_btn">
                <div class="icon theme-g-bg">
                  <i class="fa fa-whatsapp"></i>
                </div>
                <h4>{{ $t("contact.whatsApp") }}</h4>
                <a href="https://api.whatsapp.com/send?phone=+8615817481923&amp;text=Hello">+8615817481923</a>
              </div>
            </div>

            <div class="col-sm-6 col-md-6 col-lg-3 m-15px-tb wow fadeInUp" style="visibility: visible; animation-name: fadeInUp">
              <div class="feature-box-01 gtag_report_btn">
                <div class="icon theme-g-bg">
                  <i class="fa fa-phone"></i>
                </div>
                <h4>{{ $t("contact.talk") }}</h4>
                <p>
                  <a href="tel:0086-15817481923">{{ $t("contact.phone") }}</a>
                </p>
              </div>
            </div>

            <div class="col-sm-6 col-md-6 col-lg-3 m-15px-tb wow fadeInUp" style="visibility: visible; animation-name: fadeInUp">
              <div class="feature-box-01">
                <div class="icon theme-g-bg">
                  <i class="fa fa-map-marker"></i>
                </div>
                <h4>{{ $t("contact.factory") }}</h4>
                <p>
                  <a href="https://goo.gl/maps/gKiTCooRoCZp5Nh6A" target="_blank">{{ $t("contact.address") }}</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section gray-bg">
        <div class="container">
          <div class="row justify-content-center m-60px-b md-m-40px-b wow fadeInUp" style="visibility: visible; animation-name: fadeInUp">
            <div class="col-md-12 text-center">
              <div class="section-title">
                <h2 class="theme-after-bg">{{ $t("contact.contactUs") }}</h2>
              </div>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-md-12 col-lg-8">
              <div class="contact-form md-m-30px-b">
                <h2 style="font-size: 24px; padding-bottom: 0px; visibility: visible; animation-name: fadeInUp" class="wow fadeInUp">
                  {{ $t("contact.quote") }}
                </h2>
                <div class="contact-text wow fadeInUp" style="visibility: visible; animation-name: fadeInUp">
                  {{ $t("contact.meanwhile") }}
                </div>

                <div class="form-validate form-9346939a74b668948bd6579f5359526d" action="https://inquiry.digoodcms.com/api/administrator" method="POST" novalidate siq_id="autopick_5720">
                  <input name="page" type="hidden" value="/Contact" />
                  <input id="backpage" name="backpage" type="hidden" value="/Contact" />

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <input v-model="modalParameter.userName" name="contact[Name]" :placeholder="'*' + $t('contact.fullName')" class="form-control" type="text" required />
                        <span class="input-focus-effect"></span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <input v-model="modalParameter.userEmail" name="email" :placeholder="'*' + $t('contact.usEmail')" pattern="[\w!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[\w!#$%&amp;'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?" class="form-control" type="email" required />
                        <span class="input-focus-effect"></span>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <input  v-model="modalParameter.userPhone" name="contact[tel]" :placeholder="$t('contact.telephone') + ''" pattern="(\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$" class="form-control" type="number" />
                        <span class="input-focus-effect"></span>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <textarea  v-model="modalParameter.context" name="message" :placeholder="'*' + $t('contact.message')" rows="3" class="form-control" required></textarea>
                        <span class="input-focus-effect"></span>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <span class="tip" style="color: #333; font-size: 18px">*{{ $t("contact.spam") }}</span>
                    </div>
                    <div class="col-md-12">
                      <div class="send">
                        <button class="m-btn m-btn-theme" @click="submit()">
                          <i class="fa fa-envelope-o" aria-hidden="true"></i>
                          {{ $t("contact.send") }} →
                        </button>
                      </div>
                    </div>
                  </div>
                  <input class="custom-5e6d41670ebc5d6c2980f1f48b690748_ipAddress" name="custom[ipAddress]" type="hidden" value="113.91.52.137" />
                  <input class="custom-5e6d41670ebc5d6c2980f1f48b690748_countryName" name="custom[countryName]" type="hidden" value="China" />
                  <input class="custom-5e6d41670ebc5d6c2980f1f48b690748_regionName" name="custom[regionName]" type="hidden" value="Guangdong" />
                  <input class="custom-5e6d41670ebc5d6c2980f1f48b690748_cityName" name="custom[cityName]" type="hidden" value="Shenzhen" />
                  <input class="custom-5e6d41670ebc5d6c2980f1f48b690748_countryCode" name="custom[countryCode]" type="hidden" value="CN" />
                  <input class="custom-5e6d41670ebc5d6c2980f1f48b690748_zipCode" name="custom[zipCode]" type="hidden" value="" />
                  <input class="custom-5e6d41670ebc5d6c2980f1f48b690748_latitude" name="custom[latitude]" type="hidden" value="22.5318" />
                  <input class="custom-5e6d41670ebc5d6c2980f1f48b690748_longitude" name="custom[longitude]" type="hidden" value="114.1374" />
                  <input class="custom-5e6d41670ebc5d6c2980f1f48b690748_timeZone" name="custom[timeZone]" type="hidden" value="Asia/Shanghai" />

                  <input class="geo-ce1b6eab511d6ce365f9ce382548c3cb_ipAddress" name="geoip[ipAddress]" type="hidden" value="113.91.52.137" />
                  <input class="geo-ce1b6eab511d6ce365f9ce382548c3cb_countryName" name="geoip[countryName]" type="hidden" value="China" />
                  <input class="geo-ce1b6eab511d6ce365f9ce382548c3cb_countryCode" name="geoip[countryCode]" type="hidden" value="CN" />
                  <input class="geo-ce1b6eab511d6ce365f9ce382548c3cb_regionName" name="geoip[regionName]" type="hidden" value="Guangdong" />
                  <input class="geo-ce1b6eab511d6ce365f9ce382548c3cb_cityName" name="geoip[cityName]" type="hidden" value="Shenzhen" />
                  <input class="geo-ce1b6eab511d6ce365f9ce382548c3cb_zipCode" name="geoip[zipCode]" type="hidden" value="" />
                  <input class="geo-ce1b6eab511d6ce365f9ce382548c3cb_latitude" name="geoip[latitude]" type="hidden" value="22.5318" />
                  <input class="geo-ce1b6eab511d6ce365f9ce382548c3cb_longitude" name="geoip[longitude]" type="hidden" value="114.1374" />
                  <input class="geo-ce1b6eab511d6ce365f9ce382548c3cb_timeZone" name="geoip[timeZone]" type="hidden" value="Asia/Shanghai" />
                  <input name="useragent[browser]" type="hidden" value="Chrome[86.0.4240.75]" />
                  <input name="useragent[platform]" type="hidden" value="Windows 10" />
                  <input name="useragent[lang]" type="hidden" value="zh-CN,zh;q=0.9,ja;q=0.8,en-US;q=0.7,en;q=0.6,zh-TW;q=0.5" />
                  <input name="useragent[mobile]" type="hidden" value="No" />
                  <input name="useragent[agent_string]" type="hidden" value="Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/86.0.4240.75 Safari/537.36" />

                  <input name="country" type="hidden" value="CN" />
                </div>
              </div>
            </div>
            <div class="col-md-12 col-lg-4">
              <div class="contact-map">
                <iframe allowfullscreen frameborder="0" height="400" loading="lazy" referrerpolicy="no-referrer-when-downgrade" scrolling="no" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d918.4671178788668!2d114.0601342!3d22.9550706!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340381f26e8cca99%3A0x83dec004f9b3183!2zMjLCsDU3JzE5LjMiTiAxMTTCsDAzJzM1LjEiRQ!5e0!3m2!1sen!2shk!4v1668156334910!5m2!1sen!2shk" style="border: 0" width="100%"></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
<div style="position: fixed; top: 30%; left: 30%; right: 30%; z-index:1 ; text-align: center;" class="alert alert-danger" v-if="show" role="alert">{{ show }}</div>
<div style="position: fixed; top: 30%; left: 40%; right: 40%; padding: 20px 0; z-index: 1; text-align: center;" class="alert-success" v-if="successShow" role="alert">
<span class="glyphicon glyphicon-ok"></span>
</div>

  </div>
</template>


<script setup>

import { reactive,getCurrentInstance ,ref} from 'vue';
import {saveConcat} from '@/utils/api.js'
const { proxy } = getCurrentInstance()
let modalParameter = reactive({
  userName:'',
  userEmail:'',
  context:'',
  userPhone:''
})

let show = ref(false);
let  successShow = ref(false);

let submit = ()=>{
  if(  successShow.value){
    return
  }
  show.value = false;
  for(let i in modalParameter){
    if(i!='userPhone' && !modalParameter[i]){
     show.value = i == 'userName'?'fullName':i=='userEmail'?'usEmail':i=='context'?'message':'';
    }
  }
  if(show.value){
    // alert(proxy.$t('contact.'+show))
   show.value = proxy.$t('contact.'+show.value);

   setTimeout(() => {
    show.value = false;
   }, 3000);
    return
  }

  saveConcat(modalParameter).then(res=>{
    if(res.code =='000000'){
      for(let i in modalParameter){
       modalParameter[i] = '';
  }
 successShow.value = true;
  setTimeout(() => {
    successShow.value = false;
  }, 3000);
    }
  })
}

</script>

<style scoped>
iframe {
  max-width: 100% !important;
}

[digood-id="contact-hd-page"] .section {
  padding: 50px 0;
  overflow: hidden;
}

[digood-id="contact-hd-page"] .feature-box-01 h4 {
  color: var(--main-theme-color);
}

[digood-id="contact-hd-page"] .feature-box-01 {
  text-align: center;
  border-radius: 5px;
  padding: 20px;
  background: #fff;
  border: 1px solid #e5e8ed;
  height: 270px;
}

[digood-id="contact-hd-page"] .feature-box-01 .icon {
  display: inline-block;
  vertical-align: top;
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
  font-size: 30px;
  line-height: 80px;
  color: var(--main-theme-color);
  background: #f2f3f8;
  border: 1px solid #eee;
  border-radius: 100% 50% 50% 100% / 75% 69% 69% 75%;
}

[digood-id="contact-hd-page"] .feature-box-01 h4 {
  font-weight: 500;
  margin: 0 0 10px;
  font-size: 15px;
}

[digood-id="contact-hd-page"] .feature-box-01 p {
  margin: 0;
  color: #333;
  line-height: 22px;
}

[digood-id="contact-hd-page"] .feature-box-01 a {
  color: #333;
}

[digood-id="contact-hd-page"] .m-15px-tb {
  margin-top: 15px;
  margin-bottom: 15px;
}

[digood-id="contact-hd-page"] .gray-bg {
  background: #f2f3f8;
}

[digood-id="contact-hd-page"] .section-title {
  position: relative;
  text-align: center;
}

[digood-id="contact-hd-page"] .section-title label {
  font-weight: 600;
  text-transform: uppercase;
  opacity: 0.6;
  margin: 0 0 7px;
  display: none;
}

[digood-id="contact-hd-page"] .section-title h2 {
  font-weight: 600;
  font-size: 35px;
  letter-spacing: 1px;
  margin-bottom: 15px;
  text-transform: capitalize;
  position: relative;
  z-index: 1;
}

[digood-id="contact-hd-page"] .section-title h2:after {
  position: absolute;
  left: 0;
  top: 20px;
  content: "";
  width: 70px;
  height: 15px;
  border-radius: 30px;
  opacity: 0.3;
  transform: rotate(-45deg);
  right: 0;
  margin: auto;
  z-index: -1;
  box-shadow: -2px -22px 0px 0px rgba(0, 0, 0, 0.27);
}

[digood-id="contact-hd-page"] .section-title p {
  text-align: center;
  font-weight: 400;
  font-size: 15px;
  letter-spacing: 0.5px;
  color: #7f7c9b;
  margin: 0;
}

[digood-id="contact-hd-page"] .section-title label,
[digood-id="contact-hd-page"] .section-title h2 {
  color: var(--main-theme-color);
}

[digood-id="contact-hd-page"] .m-btn {
  background: var(--main-theme-color);
  padding: 12px 30px;
  border: 1px solid var(--main-theme-color);
  border-radius: 5px;
  line-height: initial;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-decoration: none !important;
  display: inline-block;
  text-transform: capitalize;
  font-size: 12px;
  cursor: pointer;
  -webkit-transition: ease all 0.3s;
  -moz-transition: ease all 0.3s;
  -o-transition: ease all 0.3s;
  transition: ease all 0.3s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
}

[digood-id="contact-hd-page"] .m-btn-theme {
  color: #fff;
}

[digood-id="contact-hd-page"] .m-btn-theme:hover {
  background: var(--sub-theme-color);
  border-color: var(--sub-theme-color);
}

[digood-id="contact-hd-page"] .form-group {
  position: relative;
  width: 100%;
  margin-bottom: 20px;
}

[digood-id="contact-hd-page"] .form-group .form-control {
  border: none;
  outline: none;
  box-shadow: none;
  height: 40px;
  padding-left: 0;
  padding-right: 0;
  border-bottom: 2px solid #dcdcdc;
  border-radius: 0;
  width: 100%;
  font-size: 14px;
  color: #000;
  background: transparent;
}

[digood-id="contact-hd-page"] .form-group textarea.form-control {
  height: 100px;
  resize: none;
}

[digood-id="contact-hd-page"] .form-group .input-focus-effect {
  width: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  -webkit-transition: ease all 0.3s;
  -o-transition: ease all 0.3s;
  transition: ease all 0.3s;
}

[digood-id="contact-hd-page"] .form-group textarea:focus:not([readonly]) + span.input-focus-effect,
[digood-id="contact-hd-page"] .form-group input:focus:not([readonly]) + span.input-focus-effect {
  width: 100%;
}

[digood-id="contact-hd-page"] .contact-form {
  background: #fff;
  padding: 20px;
  border: 1px solid #e5e8ed;
}

[digood-id="contact-hd-page"] .contact-form h2 {
  margin: 0;
  padding: 0 0 20px;
  font-size: 20px;
  color: #333;
  font-weight: 500;
  line-height: 1.1;
}

[digood-id="contact-hd-page"] .contact-form .send {
  margin-top: 10px;
}

[digood-id="contact-hd-page"] .contact-map {
  height: 432px;
  box-shadow: 0 2px 4px rgba(3, 27, 78, 0.06);
  border: 1px solid #e5e8ed;
  padding: 15px;
  background: #fff;
}

[digood-id="contact-hd-page"] .m-60px-b {
  margin-bottom: 33px;
}

[digood-id="contact-hd-page"] .embed-responsive.embed-responsive-16by9 {
  padding-bottom: 100%;
}

[digood-id="contact-hd-page"] .form-group .input-focus-effect,
[digood-id="contact-hd-page"] .theme-after-bg:after {
  background: var(--main-theme-color);
}

[digood-id="contact-hd-page"] .form-group .input-focus-effect {
  background: var(--main-theme-color);
}

[digood-id="contact-hd-page"] .feature-box-01 a:hover {
  color: var(--main-theme-color);
}

.page_title {
  text-align: center;
  color: #1e1e29;
  font-size: 35px;
  padding-bottom: 32px;
  margin-bottom: 0;
  font-weight: 600;
}

.contact-text {
  color: #333;
  font-size: 20px;
  margin-bottom: 20px;
}

@media (max-width: 991px) {
  [digood-id="contact-hd-page"] .md-m-30px-b {
    margin-bottom: 30px;
  }

  [digood-id="contact-hd-page"] .md-m-40px-b {
    margin-bottom: 40px;
  }

  [digood-id="contact-hd-page"] .section {
    padding: 40px 0;
  }

  .designer .image {
    padding: 30px 40px;
  }
}

@media (max-width: 767px) {
  span.tip {
    font-size: 16px !important;
  }

  [digood-id="contact-hd-page"] .contact-form h2 {
    font-size: 18px !important;
  }

  .contact-text {
    font-size: 16px;
    line-height: 20px;
    margin-top: 12px;
    margin-bottom: 6px;
  }

  [digood-id="contact-hd-page"] .feature-box-01 .icon {
    width: 48px;
    height: 48px;
    line-height: 48px;
    font-size: 24px;
    margin-bottom: 12px;
  }

  [digood-id="contact-hd-page"] .feature-box-01 {
    height: auto;
    padding: 14px;
  }

  [digood-id="contact-hd-page"] .md-m-40px-b {
    margin-bottom: 30px;
  }

  [digood-id="contact-hd-page"] .section-title h2:after {
    top: 14px;
    width: 54px;
    height: 12px;
  }

  [digood-id="contact-hd-page"] .form-group {
    margin-bottom: 10px;
  }

  [digood-id="contact-hd-page"] .section {
    padding: 25px 0;
  }

  [digood-id="contact-hd-page"] .section.gray-bg {
    padding: 44px 0 40px;
  }

  [digood-id="contact-hd-page"] .section-title h2 {
    font-size: 22px;
    margin-bottom: 0;
  }
}
</style>
